import {
  retryOrganisationAgentTask,
  searchOrganisationAgentTasks,
  type OrganisationAgentTaskInDb,
  type OrganisationAgentTaskSearchQuery,
  type OrganisationAgentTaskSearchResult,
} from '@/api';

export const OrganisationAgentTaskService = {
  /**
   * Search the active organisation's agent tasks with pagination, filtering and
   * search. Org-admin only (enforced server-side).
   */
  async search(
    query: OrganisationAgentTaskSearchQuery
  ): Promise<OrganisationAgentTaskSearchResult | undefined> {
    const response = await searchOrganisationAgentTasks({ body: query });

    if (!response.data) {
      throw new Error('Failed to load agent tasks.');
    }

    return response.data;
  },

  /**
   * Reset a FAILED/CANCELLED/WARNING task to PENDING and dispatch it again.
   * Org-admin only (enforced server-side).
   */
  async retry(uid: string): Promise<OrganisationAgentTaskInDb> {
    const response = await retryOrganisationAgentTask({ path: { uid } });

    if (!response.data) {
      throw new Error('Failed to retry agent task.');
    }

    return response.data;
  },
};
